import { summaryWorthyCompletionObserved, type SummaryWorthyCompletionObservation, type SummaryWorthyCompletionObservationActionMessage } from "owa-copilot-meeting-prep-summary-worthy";
import { type IsSummaryWorthyDataFetchSource } from "owa-copilot-meeting-prep-utils";
import { areFeatureFlagsInitialized, isGlobalFeatureEnabled } from "owa-feature-flags";
import { orchestrator } from "satcheljs";
import { lazyEnqueueMeetingPrepWorthinessObservation } from "../../lazyComponents";

const MEETING_PREP_WORTHINESS_FEATURE = "cal-dev-meeting-prep-worthiness";
const MEETING_PREP_WORTHINESS_KILL_SWITCH = "cal-meeting-prep-worthiness-shadow-killswitch";

const ALLOWED_PRODUCTION_SOURCES = new Set<IsSummaryWorthyDataFetchSource>([
    1,
    2,
    3,
    4,
    5,
    6,
    8,
]);

export function shouldObserveSummaryWorthyCompletion(observation: SummaryWorthyCompletionObservation): boolean {
    return (areFeatureFlagsInitialized() &&
        isGlobalFeatureEnabled(MEETING_PREP_WORTHINESS_FEATURE, true) &&
        !isGlobalFeatureEnabled(MEETING_PREP_WORTHINESS_KILL_SWITCH, true) &&
        ALLOWED_PRODUCTION_SOURCES.has(observation.dataFetchSource) &&
        observation.accountKey.length > 0 &&
        observation.eventId.length > 0);
}

export function observeSummaryWorthyCompletion(observation: SummaryWorthyCompletionObservation): void {
    if (!shouldObserveSummaryWorthyCompletion(observation)) {
        return;
    }
    
    try {
        void lazyEnqueueMeetingPrepWorthinessObservation
            .importAndExecute(observation)
            .catch(() => { });
    }
    catch {
        // Best-effort observer; never propagate into the OCS caller.
    }
}

orchestrator(summaryWorthyCompletionObserved, ({ observation }: SummaryWorthyCompletionObservationActionMessage) => {
    observeSummaryWorthyCompletion(observation);
});
